import SvgIcon from './SvgIcon.vue';
import MafButton from './MafButton.vue';
import Avatar from './Avatar.vue';
import Cover from './Cover.vue';
import MafRadio from './MafRadio.vue';
import MafInput from './MafInput.vue';
import MafFileUpload from './MafFileUpload.vue';

const components = [
  SvgIcon,
  MafButton,
  Avatar,
  Cover,
  MafRadio,
  MafInput,
  MafFileUpload
];

export default components;



// WEBPACK FOOTER //
// ./src/components/common/index.js